import { createApp } from "vue";
import { createStore } from 'vuex'
import BoxBuilder from "./components/BoxBuilder.vue";
import "./scripts/libsDependecies";
import { checkGoldClubCookie } from "./scripts/library/custom";

const template = window.theme ? window.theme.template : null;
const pageType = window.theme ? window.theme.pageType : null;
const templateName = window.theme && window.theme.pageType ? window.theme.pageType : null;
const isCheckout = Shopify ? Shopify.Checkout : null;

console.log({
    template,
    pageType,
    isCheckout
}); 

if (template == 'collection') {
    import("./scripts/library/fash-sale").catch(function (error) {
        console.warn(error);
    });

    import("./scripts/library/collection-filters").catch(function (error) {
        console.warn(error);
    });

    if (templateName === 'collection.gold-club' || templateName.includes('collection.gold')) {
        import("./pages/collection-gold-club").catch(function (error) {
            console.warn(error);
        });
    } else {
        import("./pages/collection").catch(function (error) {
            console.warn(error);
        });
    }
} else if (template == 'product') {
    import("./scripts/library/fash-sale").catch(function (error) {
        console.warn(error);
    });
    if (templateName === 'product.gold-club' || templateName.includes('product.gold')) {
        import("./pages/product-gold-club").catch(function (error) {
            console.warn(error);
        });
    } else {
        import("./pages/product").catch(function (error) {
            console.warn(error);
        });
    }
} else if (templateName === 'page.gold-club' || templateName.includes('page.gold')) {
    import("./pages/page-gold-club").catch(function (error) {
        console.warn(error);
    });
} else if (template == 'cart') {
    import("./scripts/libary/gifts-discount").catch(function (error) {
        console.warn(error);
    });

    import("./pages/cart").catch(function (error) {
        console.warn(error);
    });
} else if (pageType.includes('box-builder')) {
    import("./styles/components/box-builder.scss").then(async () => {
        /**
         * Notes:
         * 1. SCSS - first, then - js.
         */

        function parseJsons(jsonsList) {
            if (!jsonsList || jsonsList.length < 1) {
                console.error("!jsonsList || jsonsList.length < 1");
                return;
            }

            let result = [];

            jsonsList.forEach((jsonElement) => {
                result.push(JSON.parse(jsonElement.innerText));
            });

            return result;
        }

        const boxBuilderJsonsList = document.querySelectorAll(".box-builder-json");
        const boxBuildersConfigs =
            boxBuilderJsonsList.length > 0 ? parseJsons(boxBuilderJsonsList) : null;
        const boxBuilderConfig = boxBuildersConfigs[0];

        const isGoldClub = await checkGoldClubCookie();
        if (isGoldClub) {
            // Reduce product prices by 30%
            boxBuilderConfig.products_lists.forEach(pl => {
                pl.products.forEach(p => {
                    p.price -= p.price * 0.3;

                    p.variants.forEach(v => {
                        v.price -= v.price * 0.3;
                    });
                });
            });
        }

        const boxBuilderStore = createStore({
            state() {
                return {
                    selectedProducts: [],
                    addedProductsQty: 0,
                    config: boxBuilderConfig,
                    productsLists: boxBuilderConfig['products_lists'],
                    thresholds: null,
                    reachedThresholds: 0
                }
            },
            mutations: {
                addToBox(state, product) {
                    if (state.config.section.maximum_qty && state.config.section.maximum_qty > 0 && state.addedProductsQty >= state.config.section.maximum_qty) {
                        return;
                    }

                    if (!state.thresholds) {
                        return;
                    }
                    // test
                    //Unless section.settings.overdraft, then: check were less then max QTY otherwise do nothing
                    // TODO: Commented this out because we dont use overdraft anymore
                    // if (!state.config.section.overdraft && state.addedProductsQty >= state.thresholds[state.thresholds.length - 1].threshold_min) {
                    //     console.log('third');

                    //     return;
                    // }

                    let curr_prod = state.selectedProducts.findIndex(p => p.id === product.id)
                    //intial added if no QTY set from init
                    if (curr_prod == -1) {
                        product.selectedQty = 1;
                        state.selectedProducts.push(product);
                    } else {
                        const maximumAddingQty = +product.maximumAddingQty === 0 ? null : +product.maximumAddingQty;
                        if (maximumAddingQty && state.selectedProducts[curr_prod].selectedQty === maximumAddingQty) {
                            return;
                        }
                        state.selectedProducts[curr_prod].selectedQty += 1;
                    }
                    state.addedProductsQty++;
                },

                changeVariant(state, product) {
                    const pList = state.productsLists[product.position];
                    const productPosInPlistProducts = pList.products.findIndex(p => p.id === product.id);
                    state.productsLists[product.position].products[productPosInPlistProducts] = product;
                },

                removeFromBox(state, product) {
                    //check were less then max QTY otherwise do nothing
                    if (state.addedProductsQty >= 0) {
                        let curr_prod = state.selectedProducts.findIndex(p => p.id === product.id)
                        //intial added if no QTY set from init
                        if (curr_prod != -1) {
                            state.addedProductsQty--;
                            state.selectedProducts[curr_prod].selectedQty -= 1;
                            if (state.selectedProducts[curr_prod].selectedQty == 0) {
                                state.selectedProducts.splice(curr_prod, 1);
                            }
                        }
                    } else {
                        return;
                    }
                },

                initThresholds(state) {
                    const discountConditions = state.config.discountConditions;
                    state.thresholds = discountConditions.sort((a, b) => {
                        return a.d < b.d ? -1 : 1;
                    });
                },

                reachedTresholds(state) {
                    if (!state.thresholds) {
                        return;
                    }

                    state.reachedThresholds = 0;

                    state.thresholds.forEach(threshold => {
                        if (state.addedProductsQty >= threshold.threshold_min) {
                            state.reachedThresholds++;
                        }
                    });
                }
            },
            getters: {
                getProductSelectedQty(state) {
                    return (product) => {
                        let curr_prod = state.selectedProducts.findIndex(p => p.id === product.id)
                        if (curr_prod != -1) {
                            return state.selectedProducts[curr_prod].selectedQty;
                        } else {
                            return 0
                        }
                    }
                }
            }
        });

        console.log('✌️boxBuilder --->', boxBuilderStore);
        const boxBuilder = createApp(BoxBuilder);
        boxBuilder.use(boxBuilderStore);
        boxBuilder.mount("#boxBuilder");
    }).catch(error => {
        console.log('./styles/components/box-builder.scss');
        console.error(error);
    });
}

if (templateName === 'product.express') {
    $('#product-form').submit(function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: '/cart/add',
            data: $('#product-form').serialize(),
            success: function () {
                window.location.href = '/checkout';
            }
        });
    });
}
import "./scripts/library/ScrollAnimate";
import "./scripts/library/mini-cart-hover";
import "./modules/AnnouncementBar";
import "./scripts/changeProperties";
